exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".normalHeader {\n  height: 90px;\n  display: grid;\n  grid-template-columns: 200px 1fr auto;\n  grid-template-areas: \"title byline actions\"; }\n  .normalHeader H1 {\n    grid-area: title;\n    font-weight: 300;\n    color: #394f5a;\n    margin: 0px;\n    align-self: center; }\n  .normalHeader .byline {\n    grid-area: byline;\n    justify-self: start;\n    align-self: center; }\n  .normalHeader .actionBar {\n    grid-area: actions;\n    align-self: center; }\n\n.fastlinkModel-container IFRAME {\n  border: none; }\n", ""]);

// exports
